import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createSlots as _createSlots, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-474222df"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "questionListView" }
const _hoisted_2 = ["src"]

import { onMounted, ref, watch } from "vue";
import message from "@arco-design/web-vue/es/message";
import { useRouter } from "vue-router";
import { Question } from "../../../generated/models/Question";
import { QuestionListControllerService } from "../../../generated/services/QuestionListControllerService";
import { useStore } from "vuex";
import { QuestionListVO } from "../../../generated/models/QuestionListVO";
import { QuestionListCollectControllerService } from "../../../generated/services/QuestionListCollectControllerService";
import { UserControllerService } from "../../../generated/services/UserControllerService";
import { QuestionCollectControllerService } from "../../../generated/services/QuestionCollectControllerService";
import { QuestionControllerService } from "../../../generated/services/QuestionControllerService";
import { Message } from "@arco-design/web-vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'QuestionListView',
  setup(__props) {

document.title = "题单";

const router = useRouter();

// 获取登录用户
const store = useStore();
let loginUser = store.state.user.loginUser;

// 题单分页
const questionList = ref([]);
const questionListTotal = ref(0);
const questionListSearchParams = ref({
  title: "",
  pageSize: 10,
  current: 1,
  sortField: "createTime",
  sortOrder: "ascend",
});

// 具体的题单中的题目分页
const questions = ref([]);
const questionsTotal = ref(0);
const questionsSearchParams = ref({
  pageSize: 10,
  current: 1,
  sortField: "createTime",
  sortOrder: "ascend",
  questionListId: 0,
});

// 用来记录所点击的某个题单的id
const questionListId = ref(0);

// 弹窗
const actualQuestionsVisible = ref(false);
// 打开弹窗
const openActualQuestionsModal = (id: number, userId: number) => {
  questionListId.value = id;
  actualQuestionsVisible.value = true;
  getQuestionsByQuestionListId(id, userId);
};
const closeActualQuestionsModel = () => {
  actualQuestionsVisible.value = false;
};

/**
 * 页面切换
 * @param page
 */
const onQuestionListPageChange = (page: number) => {
  questionListSearchParams.value = {
    ...questionListSearchParams.value,
    current: page,
  };
};
const onQuestionsPageChange = (page: number) => {
  questionsSearchParams.value = {
    ...questionsSearchParams.value,
    current: page,
  };
};
/**
 * 页面大小切换
 * @param size
 */
const onQuestionListPageSizeChange = (size: number) => {
  questionListSearchParams.value = {
    ...questionListSearchParams.value,
    pageSize: size,
  };
};
const onQuestionsPageSizeChange = (size: number) => {
  questionsSearchParams.value = {
    ...questionsSearchParams.value,
    pageSize: size,
  };
};

/**
 * 搜索题单
 */
const getQuestionList = async () => {
  const res =
    await QuestionListControllerService.listQuestionListByPageUserUsingPost(
      questionListSearchParams.value
    );
  if (res.code == 0) {
    questionList.value = (await Promise.all(
      res.data.records.map(async (x: QuestionListVO) => {
        const user = await UserControllerService.getUserVoByIdUsingGet(
          x.userId
        );
        return { ...x, userAvatar: user.data?.userAvatar };
      })
    )) as [];
    questionListTotal.value = res.data.total;
  } else {
    message.success(res.message);
  }
};
/**
 * 监听getQuestionList函数所使用的变量的变化，改变时触发页面的重新加载
 */
watch(
  questionListSearchParams,
  () => {
    getQuestionList();
  },
  { deep: true }
);

onMounted(() => {
  getQuestionList();
});
/**
 * 收藏题单
 * @param questionListId
 */
const collectQuestion = async (questionListId: number) => {
  const res =
    await QuestionListCollectControllerService.addQuestionListCollectUsingPost({
      questionListId: questionListId,
    });
  if (res.code == 0) {
    await getQuestionList();
    message.success("收藏成功");
  } else {
    message.error("收藏失败");
  }
};

/**
 * 取消收藏题单
 * @param questionListId
 */
const unCollectQuestion = async (questionListId: number) => {
  const res =
    await QuestionListCollectControllerService.deleteQuestionListCollectUsingPost(
      {
        questionListId: questionListId,
      }
    );
  if (res.code == 0) {
    await getQuestionList();
    message.success("取消收藏成功");
  } else {
    message.error("取消收藏失败");
  }
};

/**
 * 获取某个题单的题目
 * @param questionListId 题目所属题单的id
 * @param userId 题目所属题单的创建人的id
 */
const getQuestionsByQuestionListId = async (
  questionListId: number,
  userId: number
) => {
  console.log(questionsSearchParams.value);
  const res =
    await QuestionCollectControllerService.listQuestionCollectByPageUserUsingPost(
      { ...questionsSearchParams.value, questionListId: questionListId }
    );
  if (res.code === 0) {
    questions.value = (await Promise.all(
      res.data.records.map(async (x: any) => {
        const questionVO =
          await QuestionControllerService.getQuestionVoByIdUsingGet(
            x.questionId
          );
        return {
          ...questionVO.data,
          questionListId: questionListId,
          userId: userId,
        };
      })
    )) as [];
    questionsTotal.value = res.data.total;
  } else {
    Message.error("" + res.message);
  }
};

/**
 * 题单取消收藏题目
 * @param questionId
 * @param questionListId
 */
const deleteQuestionInQuestionList = async (
  questionId: number,
  questionListId: number
) => {
  const res =
    await QuestionCollectControllerService.deleteQuestionCollectUsingPost({
      questionId: questionId,
      questionListId: questionListId,
    });
  if (res.code === 0) {
    message.success("删除成功");
  } else {
    message.error("删除失败，" + res.message);
  }
};

/**
 * 跳转到做题页面
 * @param question
 */
const toDoQuestion = (question: Question) => {
  router.push({
    path: `/view/question/${question.id}`,
  });
};

/**
 * 点击头像进行跳转
 * @param userId
 */
const goToUser = (userId: number) => {
  if (userId == loginUser.id) {
    router.push({
      path: `/mine`,
    });
  } else {
    router.push({
      path: `/Ta/${userId}`,
    });
  }
};

return (_ctx: any,_cache: any) => {
  const _component_a_input_search = _resolveComponent("a-input-search")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_list_item_meta = _resolveComponent("a-list-item-meta")!
  const _component_icon_star_fill = _resolveComponent("icon-star-fill")!
  const _component_a_list_item = _resolveComponent("a-list-item")!
  const _component_a_list = _resolveComponent("a-list")!
  const _component_icon_delete = _resolveComponent("icon-delete")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_form, {
      model: questionListSearchParams.value,
      layout: "inline",
      style: {"justify-content":"center","align-content":"center","margin":"25px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form_item, { field: "title" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input_search, {
              modelValue: questionListSearchParams.value.title,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((questionListSearchParams.value.title) = $event)),
              placeholder: "搜索题单",
              style: {"min-width":"300px","border-radius":"10px"}
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"]),
    _createVNode(_component_a_list, {
      scrollbar: true,
      "max-height": 700,
      size: 'large',
      data: questionList.value,
      "pagination-props": {
        total: questionListTotal.value,
        current: questionListSearchParams.value.current,
        pageSize: questionListSearchParams.value.pageSize,
        showTotal: true,
        showPageSize: true,
      },
      onPageSizeChange: onQuestionListPageSizeChange,
      onPageChange: onQuestionListPageChange
    }, {
      item: _withCtx(({ item }) => [
        _createVNode(_component_a_list_item, null, {
          actions: _withCtx(() => [
            (item.isCollect && item.userId != _unref(loginUser).id)
              ? (_openBlock(), _createBlock(_component_icon_star_fill, {
                  key: 0,
                  style: {"font-size":"23px","color":"rgb(247, 186, 30)"},
                  onClick: ($event: any) => (unCollectQuestion(item.id))
                }, null, 8, ["onClick"]))
              : _createCommentVNode("", true),
            (!item.isCollect && item.userId != _unref(loginUser).id)
              ? (_openBlock(), _createBlock(_component_icon_star_fill, {
                  key: 1,
                  style: {"font-size":"23px","color":"rgb(229, 230, 235)"},
                  onClick: ($event: any) => (collectQuestion(item.id))
                }, null, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_a_list_item_meta, null, {
              avatar: _withCtx(() => [
                _createVNode(_component_a_avatar, {
                  onClick: ($event: any) => (goToUser(item.userId))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      alt: "avatar",
                      src: item.userAvatar
                    }, null, 8, _hoisted_2)
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              title: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "text",
                  shape: "round",
                  status: "normal",
                  size: "medium",
                  style: {"margin":"10px"},
                  onClick: ($event: any) => (openActualQuestionsModal(item.id, item.userId))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.title), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    }, 8, ["data", "pagination-props"]),
    _createVNode(_component_a_modal, {
      width: "50%",
      visible: actualQuestionsVisible.value,
      placement: "right",
      onCancel: closeActualQuestionsModel,
      unmountOnClose: "",
      footer: false,
      closable: false
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_list, {
          data: questions.value,
          "pagination-props": {
          total: questionsTotal.value,
          current: questionsSearchParams.value.current,
          pageSize: questionsSearchParams.value.pageSize,
          showTotal: true,
          showPageSize: true,
        },
          onPageSizeChange: onQuestionsPageSizeChange,
          onPageChange: onQuestionsPageChange
        }, {
          item: _withCtx(({ item }) => [
            _createVNode(_component_a_list_item, null, _createSlots({
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "text",
                  shape: "round",
                  status: "normal",
                  size: "medium",
                  style: {"margin":"10px"},
                  onClick: ($event: any) => (toDoQuestion(item))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_list_item_meta, {
                      title: item.title
                    }, null, 8, ["title"])
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 2
            }, [
              (_unref(loginUser).id == item.userId)
                ? {
                    name: "actions",
                    fn: _withCtx(() => [
                      _createVNode(_component_a_popconfirm, {
                        content: "确定要取消收藏此题目吗?",
                        type: "error",
                        okText: "是",
                        cancelText: "否",
                        onCancel: _cache[1] || (_cache[1] = 
                  () => {
                    _unref(message).warning(`已取消`);
                  }
                ),
                        onOk: ($event: any) => (deleteQuestionInQuestionList(item.id, item.questionListId))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_icon_delete)
                        ]),
                        _: 2
                      }, 1032, ["onOk"])
                    ]),
                    key: "0"
                  }
                : undefined
            ]), 1024)
          ]),
          _: 1
        }, 8, ["data", "pagination-props"])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}
}

})